export default "__VITE_ASSET__B_5GoKeS__"